import { RECIPE_NAME_DAHLIA } from 'constants/recipes';

export const DEFAULT_RECIPE_NAME = RECIPE_NAME_DAHLIA;

export const DEFAULT_CLEANUP_MESSAGE_TIMEOUT = 6000;
